import { reactive } from "vue";

export const state = reactive({
  filename: "",
  code: "",
  isModalOpen: false,
  opened: false,
  fileHandle: null,
  readonly: false
});
